export default __webpack_public_path__ + "static/media/icon-website.b7923f6c.svg";